<div aria-label="oral-notifications-dialog">
  <app-oral-notifications-form [model]="model" [mode]="mode" (cancel)="onCancel()" (save)="onSubmit($event)"></app-oral-notifications-form>
</div>
